import {
  Active,
  EmailNote,
  InternalNote,
  Label,
  Language,
  Recipient,
  RecipientGroup,
  Revenue,
  Root,
  Scope,
  SendDay,
  SendTime,
  SettingsTitle,
} from './components';

export const ReportMailingForm = {
  Root,
  SettingsTitle,
  Label,
  Active,
  Recipient,
  RecipientGroup,
  Scope,
  SendDay,
  SendTime,
  Language,
  Revenue,
  EmailNote,
  InternalNote,
};
